import Header from "../Header";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {createConditionalRequire, createValueGroupRequired} from '../../utils';
import {submitStep} from "../../network";
import ReactGA from "react-ga";

const SubjectIntroduction = ({nextStep, currentFormStep, maxStep}) => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + "/subjectIntroduction");
    }, []);
    const [isLoading, setLoading] = useState(false);
    const onSubmit = data => {
        setLoading(true)
        submitStep("subject introduction", data)
            .then(() => {
                setLoading(false)
                nextStep()
            })
    };
    const {register, handleSubmit, errors, getValues} = useForm();
    return (<>
            <Header title="Mis kasu on sellest ainest"/>
            <progress className="progress is-link" value={currentFormStep} max={maxStep}/>
            <section className="section">
                <div className="container">
                    <figure className="image video-container">
                        <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/W1nAnNK8QXk?showinfo=0" frameborder="0"
                            allowfullscreen></iframe>
                    </figure>
                    <p className="text">
                        Selles aines saad Sa suure pildi sellest, mis on tänapäevane programmeerimine, miks seda vaja on ja kuidas programmeerijad päriselt töötavad.
                    </p>
                    <p className="text">
                        Kursuse lõpuks <strong>oskad Pythoni keeles viia ellu oma pöörased ja vähem pöörased ideed. </strong>
                        Python on väga hea keel programmeerimise õppimiseks,
                        see on selgelt kõige olulisem keel masinõppe maailmas ja #1 keel kasutussageduselt programmeerijate hulgas: <a href="https://madnight.github.io/githut/" target="_blank">GitHut</a> ja <a href="https://www.tiobe.com/tiobe-index/" target="_blank">Tiobe</a> järgi.
                    </p>
                    <p className="text">
                        Kui soovid varem või hiljem tegeleda suuremate projektidega, on Sulle kasu ka <strong>Git versioonihaldustarkvarast, mida kursusel kasutama õpime</strong> - Git on standard pea igas tiimis ja kogukonnas. 
                        Giti abiga salvestub Su kood pilve, tänu millele saavad teised arendajad seda vaadata ja vajadusel täiendada. 
                    </p>
                    <p className="text">
                        Kursuse käigus teeme palju väikseid ülesandeid, millel igal on oma <strong>tähtaeg</strong>. 
                        Kui pingutad veidi ja harjud ära koodi kirjutamisega õigeks tähtajaks, on Sul juba üks <strong>hinnatud oskus</strong> juures. 
                        Rääkimata sellest, et ka endal on mugavam, kui oled ajakavas. 
                    </p>
                    <p className="text">
                        Kui Sa siin koostöös meiega pingutad ja aine edukalt läbid, teevad õpitud teadmised ja oskused järgmistes ainetes õppimise palju lihtsamaks ja põnevamaks!
                    </p>
                    <p className="text">
                        Siin ma proovin veel asjad lühidalt kokku võtta:
                    </p>
                    <figure className="image video-container">
                        <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/WL8CzJe-7_8?showinfo=0" frameborder="0"
                            allowfullscreen></iframe>
                    </figure>
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="container">
                    <h1 className="subtitle form-question">
                        Nüüd on Sinu kord öelda - kuidas see kõik Sulle tundub?
                    </h1>
                    <div className="control">
                        <label className="checkbox">
                            <input type="checkbox" name="answer.haveDoneProgramming" ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                            See kõik on väga hästi, aga olen (Pythonis) programmeerimisega juba tegelenud
                        </label>
                    </div>
                    <div className="control">
                        <label className="checkbox">
                            <input type="checkbox" name="answer.exciting" ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                            Tundub põnev
                        </label>
                    </div>
                    <div className="control">
                        <label className="checkbox">
                            <input type="checkbox" name="answer.helpful" ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                            Küllap sellest ainest mingi kasu on
                        </label>
                    </div>
                    <div className="control">
                        <label className="checkbox">
                            <input type="checkbox" name="answer.necessary" ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                            Tundub vajalik
                        </label>
                    </div>
                    <div className="control">
                        <label className="checkbox">
                            <input type="checkbox" name="answer.onlyBecauseMandatory" ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                            Kui aine poleks kohustuslik, siis ma seda ei võtaks
                        </label>
                    </div>
                    <div className="control">
                        <label className="checkbox">
                            <input type="checkbox" name="answer.problems" ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                            Mul on mure (kirjuta kindlasti kommentaar)
                        </label>
                        <input name="answerProblems"
                           ref={register(createConditionalRequire(getValues, "answer.problems", true))}
                           className="input" type="text"/>
                    </div>
                    {Object.keys(errors).length ? <div className="validation-error">
                        Jätkamiseks vali vähemalt üks valikutest
                    </div> : null}
                    <button className={`button is-large is-rounded take-test-button ${isLoading ? 'is-loading' : ''}`} disabled={isLoading}>JÄRGMINE →</button>
                </form>
            </section>
        </>
    );
};
export default SubjectIntroduction;
